export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {
    SET_STATE (state, payload = {}) {
      const keys = Object.keys(payload)
      keys.forEach(key => state[key] = payload[key])
    }
  },
  actions: {

  },
}
